import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'TreadmillIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-treadmill",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 14l4 1l.5 -.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 18v-3l-3 -2.923l.75 -5.077"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 10v-2l4 -1l2.5 2.5l2.5 .5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 22a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 21l1 -11l2 -1"
    }, null), _createTextVNode(" ")]);
  }
};